import { ApplicationView as view } from '@aha-app/mvc';
import React, { useCallback, useMemo, useState } from 'react';
import type { MenuContent } from './ActionMenuItem';
import ActionMenuItem, { getIcon } from './ActionMenuItem';
import type RecordAction from './models/RecordAction';

const SelectionContextSubmenu: React.FC<{ action: RecordAction }> = ({
  action,
}) => {
  const [subMenuLoading, setSubMenuLoading] = useState(true);
  const [menuContent, setMenuContent] = useState<MenuContent>();

  const loadSubMenu = useCallback(async () => {
    if (!menuContent) {
      const items = await action.prepareSubmenuItems();
      setMenuContent(items ?? undefined);
      setSubMenuLoading(false);
    }
  }, [action, menuContent]);

  const menuItemContent = useMemo(() => {
    if (subMenuLoading) {
      return (
        <div style={{ textAlign: 'center' }}>
          <aha-spinner size='2.5ex' />
        </div>
      );
    }
    if (
      !menuContent ||
      (Array.isArray(menuContent) && menuContent.length === 0)
    ) {
      return (
        <aha-menu-item disabled>{action.emptySubmenuContent}</aha-menu-item>
      );
    }

    if (Array.isArray(menuContent)) {
      return menuContent.map((item, index) => (
        <ActionMenuItem action={action} item={item} key={index} />
      ));
    }

    return Object.entries(menuContent ?? {}).map(([label, items], idx) => (
      <aha-menu-group key={idx} label={label}>
        <div slot='label'>{label}</div>
        {items.map((item, index) => (
          <ActionMenuItem action={action} item={item} key={index} />
        ))}
      </aha-menu-group>
    ));
  }, [subMenuLoading, menuContent, action]);

  return (
    <aha-menu-item>
      <aha-menu submenu>
        <aha-button kind='link' slot='control' onMouseOver={loadSubMenu}>
          {getIcon(action)} {action.title}
        </aha-button>
        <aha-menu-content>{menuItemContent}</aha-menu-content>
      </aha-menu>
    </aha-menu-item>
  );
};

export default view(SelectionContextSubmenu);
